import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import './DetailCaption.scss'

const DetailCaption = ({title, category, status, content, client}) => {
  const [ detailsOpen, setDetailsOpen ] = useState(false)
  const { pathname } = useLocation()
  const categoryLink = pathname.substring(0, pathname.lastIndexOf('/'))

  const toggleDetails = (event) => {
    setDetailsOpen(!detailsOpen)
  }

  return () => (
    <div
      className={`project-detail__caption ${detailsOpen ? 'project-detail__caption--open' : ''}`}
    >
      <div className="project-detail__category">
        <span>Projects :: </span>
        <Link to={categoryLink}>
          { category }
        </Link>
      </div>
      <h2 className="project-detail__name">{ title }</h2>
      <div
        className={`project-detail__info ${detailsOpen ? 'project-detail__info--open' : ''}`}
      >
        <div className="project-detail__stats">
          {client &&
            <h3>
              <span className="project-detail__key">Client:</span>{ client }
            </h3>
          }
          {status &&
            <h3>
              <span className="project-detail__key">Status:</span>{ status }
            </h3>
          }
          {category &&
            <h3>
              <span className="project-detail__key">Category:</span>{ category }
            </h3>
          }
        </div>
          {content &&
            <div className="project-detail__description">{ content }</div>
          }
      </div>
      <button
        onClick={ toggleDetails }
        className="project-detail__toggle"
      >
        { detailsOpen ? 'hide' : 'show'} details
      </button>
    </div>
  )
}

export default DetailCaption